var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCheckmark = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "m11 20.94-7.61-6.43a1.24 1.24 0 0 1-.15-1.76l1-1.15A1.25 1.25 0 0 1 6 11.45l4 3.44a.26.26 0 0 0 .38-.06l7-11.4A1.25 1.25 0 0 1 19.19 3l1.27.79a1.25 1.25 0 0 1 .41 1.72l-9.49 15.37a.25.25 0 0 1-.38.06Z"
})));
export default SvgCheckmark;